/**
 * Fly-in
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'fly-in';

class FlyIn extends Component {

    /**
     * Component Setup
     */

    showFlyIn() {
        setTimeout(() => {
            document.querySelector('#af-flyin').style.bottom = '0';
        }, 1000);
    }

    hideFlyIn() {
        $('#af-flyin').hide(); // eslint-disable-line
    }

    setCloseStatus = (id) => {
        window.sessionStorage.setItem(id, true);
    };

    isFlyInClosed = (id) => (
        window.sessionStorage.getItem(id) === 'true'
    );

    setCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString(); // eslint-disable-line
        }
        document.cookie = name + '=' + (value || '')  + expires + '; path=/;secure'; // eslint-disable-line
    }

    getCookieValue = (name) => (
        document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '' // eslint-disable-line
    );

    setFlyInCookie = (id) => {
        this.setCookie(id, true, this.cookieDays);
    };

    isFlyInDisabled = (id) => (
        this.getCookieValue(id) === 'true' || !this.isFlyInRunning()
    );

    /*
    Determines if the current time is within the fly in on/off time.
     */
    isFlyInRunning = () => {
        if (this.offTime) {
            const currentTime = new Date();
            const onTime = new Date(this.onTime);
            const offTime = new Date(this.offTime);
            return currentTime > onTime && currentTime < offTime;
        }
        return true;
    };

    closeFlyIn = () => {
        this.hideFlyIn();
        this.setCloseStatus(this.id);
    };

    onClickCta = () => {
        this.hideFlyIn();
        this.setFlyInCookie(this.id);
    };

    setup = () => {
        if ($(`.${componentName} #af-flyin`).length === 0) { // eslint-disable-line
            return;
        }

        this.id = $('#af-flyin').attr('data-flyin-id'); // eslint-disable-line
        this.trigger = $('#af-flyin').attr('data-trigger'); // eslint-disable-line
        this.cookieDays = $('#af-flyin').attr('data-expiry'); // eslint-disable-line
        this.onTime = $('#af-flyin').attr('data-on-time');  // eslint-disable-line
        this.offTime = $('#af-flyin').attr('data-off-time');  // eslint-disable-line

        $(`.${componentName}`).appendTo('body'); // eslint-disable-line

        $(`.${componentName} .-close`).click(this.closeFlyIn); // eslint-disable-line
        $(`.${componentName} .${componentName}__cta`).click(this.onClickCta); // eslint-disable-line

        if (!this.isFlyInDisabled(this.id) && !this.isFlyInClosed(this.id)) {
            if (this.trigger === 'delay') {
                setTimeout(() => {
                    this.showFlyIn();
                }, 5000);
            } else if (this.trigger === 'scroll') {
                $(window).scroll(() => { // eslint-disable-line
                    if ($(window).scrollTop() > $('body').height() / 2) { // eslint-disable-line
                        this.showFlyIn();
                    }
                });
            } else {
                this.showFlyIn();
            }
        }
    };

    /**
     * Initialize Component
     */
    init() {
        window.addEventListener('fly-in-init', () => this.setup());
        this.setup();
    }

}

registerComponent('.fly-in-config', FlyIn);
